




































































import Vue from 'vue';
import Login from '@/views/Login.vue';
import Credentials from '@/models/Credentials';

export default Vue.extend({
  name: 'App',
  components: {
    Login,
  },
  data() {
    return {
      items: [
        { title: 'Dashboard', icon: 'mdi-view-dashboard', id: 'home' },
        { title: 'Utilisateurs', icon: 'mdi-account', id: 'users' },
        { title: 'Paramètres', icon: 'mdi-settings', id: 'settings' },
      ],
      right: null,
      drawer: true,
      loading: false,
      snackbar_incorrect: false,
      snackbar_error: false,
      username: '',
      password: '',
    };
  },
  created() {
    // @ts-ignore
    this.$vuetify.theme.dark = true;
  },
  methods: {
    redirect(id: string) {
      this.$router.push(id);
    },
    logout() {
      this.$store.state.credentials = new Credentials('', '');
      this.$store.state.logged = false;
    },
  },
});
